import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Background from 'components/ui/background/background';
import Landing from './landing/landing';
import ChooseLanguage from 'components/choose-language/choose-language';
import ModulesOverview from './modules-overview/modules-overview';
import ModuleController from './module/module-controller';
import './game.scss';

const Game = (props) => {
	const {
		shakeScreen,
		languageId, 
		backgroundId,
		backgroundModifier,
		backgroundStatus,
		playerData, 
		deviceInfo,
		scrollToTop, 
		updatePlayerData, 
		resetPlayerData, 
		startNewSessionInModule,
		setBackground,
		updateBackgroundStatus,
		handleShakeScreen
	} = props;

	/* Game page */
	const [navigation, setNavigation] = useState({
		pageId: 'landing', 
		moduleId: null
	});

	/**
	 * Go to game page
	 * @param {string} pageId
	 * @param {string} moduleId
	 */
	const handleGoToGamePage = (pageId, moduleId = null) => {
		if (pageId === 'landing' || pageId === 'modules-overview') {
			setBackground(languageId, 'default', null);
		}
		setNavigation({pageId, moduleId});
	};

	/* Game page component */
	let GamePageComponent = Landing;
	if (playerData) {
		if (navigation.pageId === 'choose-language') {
			GamePageComponent = ChooseLanguage;
		} else if (navigation.pageId === 'modules-overview') {
			GamePageComponent = ModulesOverview;
		} else if (navigation.pageId === 'module' && navigation.moduleId) {
			GamePageComponent = ModuleController;
		}
	}

	return (
		<div className={'Game ' + navigation.pageId + (shakeScreen ? ' shake' : '')}>
			<Background
				backgroundId={backgroundId}
				backgroundModifier={backgroundModifier}
				backgroundStatus={backgroundStatus}
				updateBackgroundStatus={updateBackgroundStatus}
				deviceInfo={deviceInfo}
			/>
			{backgroundStatus !== 'fade' && <GamePageComponent 
				languageId={languageId}
				backgroundStatus={backgroundStatus}
				moduleId={navigation.moduleId}
				playerData={playerData}
				deviceInfo={deviceInfo}
				scrollToTop={scrollToTop}
				handleGoToGamePage={handleGoToGamePage}
				updatePlayerData={updatePlayerData}
				resetPlayerData={resetPlayerData}
				startNewSessionInModule={startNewSessionInModule}
				setBackground={setBackground}
				handleShakeScreen={handleShakeScreen}
			/>}
		</div>
	);
};

Game.propTypes = {
	shakeScreen: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	backgroundId: PropTypes.string.isRequired,
	backgroundModifier: PropTypes.string,
	backgroundStatus: PropTypes.string.isRequired,
	playerData: PropTypes.object,
	deviceInfo: PropTypes.object.isRequired,
	scrollToTop: PropTypes.func.isRequired,
	updatePlayerData: PropTypes.func.isRequired,
	resetPlayerData: PropTypes.func.isRequired,
	startNewSessionInModule: PropTypes.func.isRequired,
	setBackground: PropTypes.func.isRequired,
	updateBackgroundStatus: PropTypes.func.isRequired,
	handleShakeScreen: PropTypes.func.isRequired,
};

export default Game;
